module.exports = __webpack_public_path__ + "img/7.e741cfe8.jpg";